export default function Button({ children, variant = "default", size = "default", className = "", ...props }) {
    const baseStyles =
      "inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none"
  
    const variantStyles = {
      default: "bg-red-500 hover:bg-red-600 text-white",
      outline: "border border-red-500 text-red-500 hover:bg-red-500/10",
      ghost: "hover:bg-zinc-800 text-zinc-400 hover:text-white",
    }
  
    const sizeStyles = {
      default: "h-10 py-2 px-4",
      sm: "h-9 px-3 rounded-md",
      lg: "h-12 px-8 rounded-md text-lg",
    }
  
    const combinedClassName = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`
  
    return (
      <button className={combinedClassName} {...props}>
        {children}
      </button>
    )
  }
  
  